/**
 * Stable classic-script entry for Liquid-direct storefronts.
 *
 * The entry intentionally contains no feature imports. It loads one shared
 * ESM runtime and lets that runtime request only the registration modules
 * whose DOM markers are present on the current page.
 */
const currentScript = document.currentScript;
const scriptSource =
  currentScript instanceof HTMLScriptElement
    ? currentScript.src
    : new URL('/islands/islands.js', document.baseURI).href;
declare const __DKH_RUNTIME_MODULE_PATH__: string;
const modulePath =
  typeof __DKH_RUNTIME_MODULE_PATH__ === 'string'
    ? __DKH_RUNTIME_MODULE_PATH__
    : './modules/';
const moduleBaseUrl = new URL(modulePath, scriptSource);

type RuntimeModule = typeof import('./islands-standalone-runtime');
type DynamicImport = (url: string) => Promise<RuntimeModule>;

// Keep the stable entry as an IIFE/classic script while retaining native ESM
// code splitting for the feature graph. The indirection prevents esbuild from
// folding the dynamic import back into islands.js.
const dynamicImport = new Function(
  'url',
  'return import(url);'
) as DynamicImport;

void dynamicImport(new URL('runtime.js', moduleBaseUrl).href).then(
  (runtime) => {
    runtime.bootstrapStandaloneRuntime({ moduleBaseUrl });
  }
);
